import { render, staticRenderFns } from "./ModalAbout.vue?vue&type=template&id=3d8c81c2&"
import script from "./ModalAbout.vue?vue&type=script&lang=js&"
export * from "./ModalAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports